import { useState, type FormEvent, type JSX } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';
import { mensagemDoErro } from '../lib/api.js';
import { definirSlugManual, precisaEscolherTenant, slugAtual } from '../lib/tenant.js';
import './Login.css';

interface EstadoDeRota {
  de?: string;
}

/** Entrada no sistema — Story 8.1 (RF-02). */
export function Login(): JSX.Element {
  const { usuario, entrar, restaurando } = useAuth();
  const local = useLocation();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [slug, setSlug] = useState(slugAtual() ?? '');
  const [erro, setErro] = useState<unknown>(undefined);
  const [enviando, setEnviando] = useState(false);

  // Em produção o subdomínio resolve o tenant e este campo nem aparece.
  const pedirTenant = precisaEscolherTenant();

  if (usuario !== undefined) {
    const destino = (local.state as EstadoDeRota | null)?.de ?? '/catalogo';
    return <Navigate to={destino} replace />;
  }

  async function aoEnviar(evento: FormEvent<HTMLFormElement>): Promise<void> {
    evento.preventDefault();
    setErro(undefined);
    setEnviando(true);
    try {
      // Precisa valer ANTES do login: é o header que identifica o tenant.
      if (pedirTenant) definirSlugManual(slug);
      await entrar(email.trim(), senha);
    } catch (e) {
      setErro(e);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="login">
      <div className="login__cartao cartao">
        <div className="login__marca">
          <h1 className="login__titulo">Orçamentos</h1>
          <p className="login__sub">Sistema de orçamentos de revestimentos</p>
        </div>

        <form
          className="login__form"
          onSubmit={(e) => {
            void aoEnviar(e);
          }}
          noValidate
        >
          {pedirTenant && (
            <label className="campo">
              <span className="campo__rotulo">Empresa</span>
              <input
                className="campo__entrada"
                value={slug}
                onChange={(e) => {
                  setSlug(e.target.value);
                }}
                placeholder="identificador da empresa"
                autoComplete="organization"
                required
              />
              <span className="login__dica">
                Em produção a empresa vem do endereço de acesso; aqui você informa porque o ambiente
                local não tem subdomínio.
              </span>
            </label>
          )}

          <label className="campo">
            <span className="campo__rotulo">E-mail</span>
            <input
              className="campo__entrada"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              autoComplete="username"
              autoFocus
              required
            />
          </label>

          <label className="campo">
            <span className="campo__rotulo">Senha</span>
            <input
              className="campo__entrada"
              type="password"
              value={senha}
              onChange={(e) => {
                setSenha(e.target.value);
              }}
              autoComplete="current-password"
              required
            />
          </label>

          {erro !== undefined && (
            <p className="aviso" role="alert">
              {mensagemDoErro(erro)}
            </p>
          )}

          <button
            type="submit"
            className="botao botao--primario botao--bloco"
            disabled={enviando || restaurando}
          >
            {enviando ? 'Entrando…' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
